/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createMapTransform } from '../../factoriesAny.js';
export var mapTransformDependencies = {
  typedDependencies: typedDependencies,
  createMapTransform: createMapTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMapTransform.generated.js
// module id = 1450
// module chunks = 0